import { render, staticRenderFns } from "./billing-modal-patient-selection.vue?vue&type=template&id=01435a74&scoped=true&"
import script from "./billing-modal-patient-selection.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-patient-selection.ts?vue&type=script&lang=ts&"
import style0 from "./billing-modal-patient-selection.scss?vue&type=style&index=0&id=01435a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01435a74",
  null
  
)

export default component.exports